import { useEffect } from "react";
import { Link } from "react-router";
import homeAccount from "../../assets/home-guide/home-account.png";
import homeStopLoss from "../../assets/home-guide/home-stoploss.png";
import homeEnroll from "../../assets/home-guide/home-enroll.png";
import homeCheck from "../../assets/home-guide/home-check.png";
import homeBlog from "../../assets/home-guide/home-blog-banner.png";
import premiumInvoice from "../../assets/finance-guide/premium-invoice.png";
import claimsFunding from "../../assets/finance-guide/claims-funding.png";
import visitPlan from "../../assets/provider-guide/visit-plan.png";
import visitDefinition from "../../assets/provider-guide/visit-definition.png";
import visitBenefitNetwork from "../../assets/provider-guide/visit-benefit-network.png";
import visitSupplierNetwork from "../../assets/provider-guide/visit-supplier-network.png";
import visitSupplier from "../../assets/provider-guide/visit-supplier.png";
import visitRole from "../../assets/provider-guide/visit-role.png";
import visitPractitioner from "../../assets/provider-guide/visit-practitioner.png";
import claimStatus from "../../assets/claims-guide/claim-status.png";
import claimSubmit from "../../assets/claims-guide/claim-submit.png";
import claimValidate from "../../assets/claims-guide/claim-validate.png";
import claimBenefits from "../../assets/claims-guide/claim-benefits.png";
import moneyAccums from "../../assets/claims-guide/money-accums.png";
import paymentOut from "../../assets/finance-guide/payment-out.png";
import "../provider/ProviderGuide.scss";
import "./HomeGuide.scss";

const MONEY = [
    {
        dir: "In",
        img: premiumInvoice,
        alt: "A premium invoice",
        kicker: "Billing cycle",
        name: "What the employer owes us",
        detail: "The cycle creates the bills from the rates. Then premium payments land against those bills.",
        steps: [
            { to: "/finance/billing-rates", label: "Billing rates" },
            { to: "/finance/bills", label: "Bills" },
            { to: "/finance/payments", label: "Premium payments" },
        ],
    },
    {
        dir: "Out",
        img: claimsFunding,
        alt: "A claim and a money bag",
        kicker: "Payment cycle",
        name: "What we owe providers",
        detail: "A self-funded run picks claim payables and creates the funding request. After the cash is in, Zelis sends the checks.",
        steps: [
            { to: "/finance/payment-cycles", label: "Payment cycle" },
            { to: "/finance/funding-requests", label: "Funding request" },
            { to: "/finance/guide", label: "Funding payment" },
        ],
    },
];

const STOPLOSS = [
    {
        name: "Specific",
        detail: "One member’s claims above a threshold. The policy reimburses that excess.",
    },
    {
        name: "Aggregated",
        detail: "The whole group’s claims above a corridor. Protects the account, not one person.",
    },
];

const PLAN = [
    { to: "/members", img: homeEnroll, alt: "Members and an ID card", kicker: "Coverage tier", detail: "On the enrollment", name: "Employee only, EE + spouse, family" },
    { to: "/config/templates", img: visitDefinition, alt: "A clipped list", kicker: "Template", detail: "Copied into a new plan", name: "Starting shape" },
    { to: "/config/components", img: visitPlan, alt: "Plan pieces", kicker: "Component", detail: "Shared across plans", name: "Reusable pieces" },
    { to: "/config/plans", img: moneyAccums, alt: "A ledger", kicker: "Riders", detail: "Often where accums map", name: "Add-ons on that plan" },
    { to: "/config/value-list", img: visitDefinition, alt: "A list", kicker: "Value list", detail: "Codes, types, groups", name: "Named sets the plan uses" },
    { to: "/config/provisions", img: visitPlan, alt: "Plan rules", kicker: "Provisions", detail: "What the claim evaluates", name: "The if/then rules" },
    { to: "/config/plans", img: moneyAccums, alt: "Accumulator ledger", kicker: "Accums", detail: "Deductible, OOP, visits", name: "Buckets a claim writes" },
    { to: "/claims/guide", img: claimStatus, alt: "A stamped claim", kicker: "Repricer", detail: "When no contract matches", name: "Fallback allowed amount" },
    { to: "/claims/guide", img: claimStatus, alt: "A claim form", kicker: "COB", detail: "Coordination of benefits", name: "Other payer first or second" },
    { to: "/finance/bank-account", img: paymentOut, alt: "A document to a coin", kicker: "Bank account", detail: "For claim payments", name: "Where the plan pays from" },
    { to: "/config/network-definitions", img: visitDefinition, alt: "Network list", kicker: "Network definition", detail: "IN / OON buckets", name: "Benefit networks on the plan" },
];

const CODES = [
    { to: "/codes/services", img: visitDefinition, alt: "A code list", kicker: "CPT / HCPCS", detail: "What was done", name: "Office visit, imaging, supply" },
    { to: "/codes/diagnosis", img: visitPlan, alt: "A diagnosis list", kicker: "ICD diagnosis", detail: "Why it was done", name: "The condition on the claim" },
    { to: "/codes/revenue", img: moneyAccums, alt: "A facility ledger", kicker: "Revenue", detail: "On a facility line", name: "UB department code" },
    { to: "/codes/drugs", img: claimBenefits, alt: "A plan booklet", kicker: "NDC", detail: "The drug billed", name: "Pharmacy or medical drug" },
    { to: "/codes/place-of-service", img: visitSupplier, alt: "A clinic", kicker: "Place of service", detail: "On a professional line", name: "Office, ER, inpatient" },
    { to: "/codes/type-of-bill", img: claimSubmit, alt: "A claim form", kicker: "Type of bill", detail: "On a facility claim", name: "Inpatient vs outpatient" },
    { to: "/codes/modifiers", img: visitRole, alt: "A clinician at a clinic", kicker: "Modifiers", detail: "How it was done", name: "Bilateral, professional, TC" },
    { to: "/codes/procedures", img: visitDefinition, alt: "A procedure list", kicker: "ICD procedure", detail: "What the facility did", name: "Not CPT — institutional only" },
    { to: "/codes/condition", img: claimValidate, alt: "A claim checklist", kicker: "Condition", detail: "On a facility header", name: "UB condition code" },
    { to: "/codes/occurrence", img: claimStatus, alt: "A stamped claim", kicker: "Occurrence", detail: "On a facility header", name: "When something happened" },
];

const BILL_FORMS = [
    {
        name: "Professional",
        detail: "CMS-1500 / 837P. CPT or HCPCS, diagnosis, place of service, and modifiers.",
    },
    {
        name: "Institutional",
        detail: "UB-04 / 837I. Revenue code, type of bill, ICD procedures, condition and occurrence.",
    },
];

const CODING_STEPS = [
    { to: "/codes/services", label: "Pick the codes" },
    { to: "/edi/ingestion", label: "Submit the 837" },
    { to: "/coverage", label: "Map to benefits" },
    { to: "/claims/guide", label: "Price and pay" },
];

const WHO = [
    { to: "/providers/suppliers", img: visitSupplier, alt: "A clinic", kicker: "Supplier", detail: "Who billed the visit", name: "Clinic, hospital, or group" },
    { to: "/providers/suppliers", img: visitSupplier, alt: "A clinic location", kicker: "Location", detail: "On that supplier", name: "Where the service happened" },
    { to: "/providers/practitioners", img: visitPractitioner, alt: "A clinician", kicker: "Practitioner", detail: "Matched on the claim", name: "The person — NPI, TIN, HCC" },
    { to: "/providers/roles", img: visitRole, alt: "A clinician at a clinic", kicker: "Role", detail: "Practitioner at a supplier", name: "That person at that clinic" },
    { to: "/providers/contracts", img: visitSupplierNetwork, alt: "A roster", kicker: "Contract", detail: "Terms for that supplier", name: "The deal and the fee table" },
    { to: "/providers/fee-components", img: paymentOut, alt: "A dollar", kicker: "Fee schedule", detail: "What pricing uses", name: "Allowed amount on the line" },
];

const Card = ({ to, img, alt, kicker, name, detail }) => {
    const inner = (
        <>
            <img src={img} alt={alt} />
            <span>{kicker}</span>
            {detail ? <em>{detail}</em> : null}
            <strong>{name}</strong>
        </>
    );
    if (to) {
        return (
            <Link to={to} className="provider-guide__card home-guide__card">
                {inner}
            </Link>
        );
    }
    return <div className="provider-guide__card home-guide__card">{inner}</div>;
};

const HomeGuide = () => {
    useEffect(() => {
        const nodes = document.querySelectorAll(".home-guide [data-reveal]");
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) {
            nodes.forEach((n) => n.classList.add("is-in"));
            return undefined;
        }
        const root = document.querySelector(".home-guide");
        const reveal = () => {
            const view = root.getBoundingClientRect();
            nodes.forEach((n) => {
                if (n.classList.contains("is-in")) return;
                const box = n.getBoundingClientRect();
                if (box.top < view.bottom - 40) {
                    n.classList.add("is-in");
                }
            });
        };
        reveal();
        root.addEventListener("scroll", reveal, { passive: true });
        window.addEventListener("resize", reveal);
        return () => {
            root.removeEventListener("scroll", reveal);
            window.removeEventListener("resize", reveal);
        };
    }, []);

    return (
        <div className="container provider-guide home-guide">
            <div className="provider-guide__frame">
                <header className="provider-guide__intro" data-reveal>
                    <p className="provider-guide__eyebrow">Home</p>
                    <h1>How this app is organized</h1>
                    <p>
                        Everything hangs off an <strong>Account</strong> — the employer. Then
                        stop-loss and the plan, then who is in-network, then money and claims.
                    </p>
                </header>

                <aside className="home-guide__promo" data-reveal>
                    <img src={homeBlog} alt="Two people sharing a notebook and asking a question" />
                    <div>
                        <p className="provider-guide__eyebrow">For whoever comes next</p>
                        <strong>Talk it through with the Writer assistant.</strong>
                        <p>
                            It interviews you and fills the post so you can review before
                            you publish. A short note, or the question you still have,
                            still helps the next person find the door.
                        </p>
                        <div className="home-guide__promo-actions">
                            <Link to="/blog/new" className="home-guide__promo-btn">Share a note</Link>
                            <Link to="/blog" className="home-guide__promo-btn home-guide__promo-btn--ghost">See what others left</Link>
                        </div>
                    </div>
                </aside>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">The hub</p>
                        <h2>Account</h2>
                        <p>
                            The top account is the employer you pick first. Billing, payment,
                            stop-loss, and the benefit plan all sit under it.
                        </p>
                    </header>
                    <Link to="/config/account-hierarchy" className="home-guide__hub">
                        <img src={homeAccount} alt="An employer building and a plan folder" />
                        <div>
                            <span>Start here</span>
                            <strong>Top account</strong>
                            <p>The employer. Every cycle and plan below names this account.</p>
                        </div>
                    </Link>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">Protection</p>
                        <h2>Stop loss</h2>
                        <p>
                            Reinsurance on the account. Specific is one member. Aggregated is
                            the group.{" "}
                            <Link to="/claims/guide#stoploss">When a claim counts toward it</Link>
                        </p>
                    </header>
                    <div className="home-guide__split">
                        <div className="home-guide__hub home-guide__hub--static">
                            <img src={homeStopLoss} alt="An umbrella over a building" />
                            <div>
                                <span>On the account</span>
                                <strong>Stop-loss policy</strong>
                                <p>Sits next to billing and claims, not inside a single claim.</p>
                            </div>
                        </div>
                        <ul className="home-guide__pair">
                            {STOPLOSS.map((row) => (
                                <li key={row.name}>
                                    <strong>{row.name}</strong>
                                    <p>{row.detail}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">The plan</p>
                        <h2>Benefit plans</h2>
                        <p>
                            What a member is covered for. Accumulators are mapped on the plan
                            (often with a rider) so a finalized claim knows which buckets to
                            write.
                        </p>
                    </header>
                    <ol className="home-guide__grid">
                        {PLAN.map((row) => (
                            <li key={row.kicker}>
                                <Card to={row.to} img={row.img} alt={row.alt} kicker={row.kicker} detail={row.detail} name={row.name} />
                            </li>
                        ))}
                    </ol>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">Networks</p>
                        <h2>Benefit network, then supplier network</h2>
                        <p>
                            The plan includes benefit networks (the IN bucket). A benefit
                            network includes supplier networks (the contracting roster).
                        </p>
                    </header>
                    <ol className="home-guide__stack">
                        <li>
                            <Card
                                to="/config/network-definitions"
                                img={visitDefinition}
                                alt="A list of network buckets"
                                kicker="Definition"
                                detail="On the plan"
                                name="Names the benefit networks"
                            />
                        </li>
                        <li aria-hidden="true" className="home-guide__join">
                            includes
                        </li>
                        <li>
                            <Card
                                to="/providers/networks?type=benefit"
                                img={visitBenefitNetwork}
                                alt="A shield for the in-network bucket"
                                kicker="Benefit network"
                                detail="The IN / OON bucket"
                                name="Included by the definition"
                            />
                        </li>
                        <li aria-hidden="true" className="home-guide__join">
                            includes
                        </li>
                        <li>
                            <Card
                                to="/providers/networks?type=supplier"
                                img={visitSupplierNetwork}
                                alt="Clinics grouped as a roster"
                                kicker="Supplier network"
                                detail="The contracting roster"
                                name="Included by the benefit network"
                            />
                        </li>
                    </ol>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">Who gets paid</p>
                        <h2>Suppliers and clinicians</h2>
                    </header>
                    <ol className="home-guide__grid home-guide__grid--six">
                        {WHO.map((row) => (
                            <li key={row.kicker}>
                                <Card to={row.to} img={row.img} alt={row.alt} kicker={row.kicker} detail={row.detail} name={row.name} />
                            </li>
                        ))}
                    </ol>
                    <p className="home-guide__hint">
                        <Link to="/providers/guide">How to look up a provider</Link>
                    </p>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">People</p>
                        <h2>Enrollments</h2>
                        <p>
                            Members on the account. Coverage dates decide if a claim can pay.
                        </p>
                    </header>
                    <Link to="/members" className="home-guide__hub">
                        <img src={homeEnroll} alt="Members and an ID card" />
                        <div>
                            <span>On the plan</span>
                            <strong>Members</strong>
                            <p>Enrollment is what coverage and claims look up.</p>
                        </div>
                    </Link>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">The bill</p>
                        <h2>Medical coding and billing</h2>
                        <p>
                            A coder turns the visit into codes. The bill (837) carries those
                            codes. HRP uses them to find the service category, the network
                            tier, and what the member pays.
                        </p>
                    </header>
                    <div className="home-guide__split">
                        <article className="home-guide__track home-guide__track--in">
                            <img src={claimValidate} alt="A claim being checked against a code list" />
                            <span className="home-guide__dir">Process</span>
                            <span>From visit to payable</span>
                            <strong>Code it, bill it, adjudicate it</strong>
                            <p>
                                Diagnosis explains why. CPT, HCPCS, revenue, or NDC is what
                                was done. Place of service or type of bill says where.
                                Modifiers qualify the line. Then the 837 goes to HRP.
                            </p>
                            <ol>
                                {CODING_STEPS.map((step) => (
                                    <li key={step.label}>
                                        <Link to={step.to}>{step.label}</Link>
                                    </li>
                                ))}
                            </ol>
                        </article>
                        <ul className="home-guide__pair">
                            {BILL_FORMS.map((row) => (
                                <li key={row.name}>
                                    <strong>{row.name}</strong>
                                    <p>{row.detail}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <ol className="home-guide__grid">
                        {CODES.map((row) => (
                            <li key={row.kicker}>
                                <Card to={row.to} img={row.img} alt={row.alt} kicker={row.kicker} detail={row.detail} name={row.name} />
                            </li>
                        ))}
                    </ol>
                    <p className="home-guide__hint">
                        Look up any of these under{" "}
                        <Link to="/codes/services">Codes</Link>
                        .
                    </p>
                </section>

                <section className="home-guide__section" data-reveal>
                    <header>
                        <p className="provider-guide__eyebrow">Money</p>
                        <h2>Two cycles on the same account</h2>
                        <p>
                            Billing cycle creates premium bills. Payment cycle creates funding
                            requests from claim payables. They run side by side.
                        </p>
                    </header>
                    <ul className="home-guide__money">
                        {MONEY.map((row) => (
                            <li key={row.kicker}>
                                <article className={`home-guide__track home-guide__track--${row.dir.toLowerCase()}`}>
                                    <img src={row.img} alt={row.alt} />
                                    <span className="home-guide__dir">{row.dir}</span>
                                    <span>{row.kicker}</span>
                                    <strong>{row.name}</strong>
                                    <p>{row.detail}</p>
                                    <ol>
                                        {row.steps.map((step) => (
                                            <li key={step.label}>
                                                <Link to={step.to}>{step.label}</Link>
                                            </li>
                                        ))}
                                    </ol>
                                </article>
                            </li>
                        ))}
                    </ul>
                    <p className="home-guide__hint">
                        Funding is the employer cash call. Paying the provider is later — Zelis
                        sends the check.{" "}
                        <Link to="/finance/guide">How money moves</Link>
                    </p>
                </section>

                <section className="home-guide__section home-guide__closers" data-reveal>
                    <Link to="/claims/guide" className="home-guide__hub">
                        <img src={claimStatus} alt="A finished claim with a stamp" />
                        <div>
                            <span>A claim</span>
                            <strong>Adjudication</strong>
                            <p>
                                Submit → match → validate → coverage → price → benefits →
                                payable → payment run.
                            </p>
                        </div>
                    </Link>
                    <div className="home-guide__hub home-guide__hub--static">
                        <img src={homeCheck} alt="An envelope and a check" />
                        <div>
                            <span>After funding</span>
                            <strong>Zelis checks</strong>
                            <p>
                                Outbound provider payment. Not the funding request — that is
                                the employer cash call.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default HomeGuide;
